import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { OrderDetailView } from '../components/order-detail/OrderDetailView';
import {
  parseItemParam,
  useWasserijItemDrawerStore,
} from '../stores/wasserij-item-drawer-store';

export function OrderDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const openItemId = useWasserijItemDrawerStore((s) => s.openItemId);
  const open = useWasserijItemDrawerStore((s) => s.open);
  const close = useWasserijItemDrawerStore((s) => s.close);

  // URL → store (initial + param-change)
  useEffect(() => {
    const fromUrl = parseItemParam(searchParams.get('item'));
    if (fromUrl && fromUrl !== openItemId) open(fromUrl);
    if (!fromUrl && openItemId) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Store → URL
  useEffect(() => {
    const current = searchParams.get('item');
    if (openItemId && current !== openItemId) {
      setSearchParams(
        (sp) => {
          sp.set('item', openItemId);
          return sp;
        },
        { replace: true }
      );
    } else if (!openItemId && current) {
      setSearchParams(
        (sp) => {
          sp.delete('item');
          return sp;
        },
        { replace: true }
      );
    }
  }, [openItemId, searchParams, setSearchParams]);

  // Sluit drawer op page-unmount zodat hij niet blijft hangen bij route-wissel
  useEffect(() => {
    return () => close();
  }, [close]);

  if (!id) {
    return (
      <>
        <div className="flex-1 flex items-center justify-center text-sm text-slate-400">
          Geen order-ID opgegeven
        </div>
      </>
    );
  }

  return (
    <>
      <OrderDetailView orderId={id} variant="page" />
    </>
  );
}
